import { ShareToLinkedinMeta, ShareToLinkedinPayload } from 'types/store/ShareToLinkedin';
import { createAsyncReducer } from 'utils/Redux';

import { shareToLinkedinActions } from '../actions';

export default createAsyncReducer<ShareToLinkedinMeta, ShareToLinkedinPayload>(shareToLinkedinActions);
